module.exports = __webpack_public_path__ + "img/fortmatic.e33911f5.svg";